import { graColor } from '@/echartOption/common';
import { getStateOption } from '@/utils/deviceUtils/state';
import { throughTime } from '@/utils/utils';

const color = {
  normal: 'rgb(3, 179, 110)'
};

const sampleDict = [
  { state: 0, des: '不能采样', open: -1, color: color.normal },
  { state: 1, des: '设备等待采样中', open: 0, color: color.normal },
  { state: 2, des: '采样倒计时', open: 1, color: color.normal },
  { state: 3, des: '采样中', open: 1, color: color.normal },
  { state: 4, des: '中断采样', open: 1, color: color.normal },
  { state: 5, des: '采样偏差', open: 1, color: color.normal },
  { state: 6, des: '采样结束', open: 0, color: color.normal }
];

const sampleResultDict = [
  { state: '0', des: '未开始', color: color.normal },
  { state: '1', des: '未出结果', color: color.normal },
  { state: '2', des: '成功', color: color.normal },
  { state: '3', des: '中断', color: color.normal },
  { state: '4', des: '载体取走', color: color.normal },
  { state: '5', des: '偏差', color: color.normal },
  { state: '6', des: '未完成', color: color.normal }
];

const doorStateDict = [
  { state: 0, des: '关门' },
  { state: 1, des: '开门' }
];

const vehicleStateDict = [
  { state: 0, des: '不存在' },
  { state: 1, des: '存在' }
];

const controlStateDict = [
  { state: 0, des: '手动' },
  { state: 1, des: '自动' },
  { state: 2, des: '手动+自动' }
];

const pumpStateDict = [
  { state: 0, des: '停止', color: color.normal },
  { state: 1, des: '运行', color: color.normal }
];

const wifiStateDict = [
  { state: 0, des: '未连接' },
  { state: 1, des: '已连接' }
];

const batteriesStateDict = [
  { state: 0, des: '未充电' },
  { state: 1, des: '充电中' }
];

function getOption(state, options) {
  return options.find(e => String(state) === String(e.state));
}

export function getBatteriesState(state) {
  return getOption(state, batteriesStateDict);
}

export function getControlState(state) {
  return getOption(state, controlStateDict);
}

export function getPumpState(state) {
  return getOption(state, pumpStateDict);
}

export function getSampleSatate(state) {
  return getOption(state, sampleDict) || {};
}

export function getVehicleState(state) {
  return getOption(state, vehicleStateDict);
}

export function getDoorState(state) {
  return getOption(state, doorStateDict);
}

export function getWifiState(state) {
  return getOption(state, wifiStateDict);
}

export function getSampleResult(state) {
  return getOption(state, sampleResultDict);
}

export function getState({ state, runstate }) {
  const res = getStateOption({ state, runstate });
  return { color: res.c, des: res.t };
}

export function getVolumVal([sampleStandardVolum, sampleVolum]) {
  return `${sampleStandardVolum || 0}L / ${sampleVolum || 0}L`;
}

/**
 * @Row { label: string; prop: string; unit: string; slot: string }
 * @type { [Group[Column[Row[]]]] }
 */
export const pageTopModel = [
  [
    [
      { label: '设备名称', prop: 'name' },
      { label: '设备编号', prop: 'sn' },
      { label: '设备状态', prop: 'state', format: v => getState({ state: v }) },
      { label: '运行状态', prop: 'runstate', format: v => getState({ runstate: v }) }
    ],
    [
      { label: '温度', prop: 'temp', unit: '℃' },
      { label: '湿度', prop: 'humidity', unit: '%RH' },
      { label: '气压', prop: 'pressure', unit: 'kpa' }
    ]
  ],
  [
    [
      { label: '设备采样', prop: 'sampleState', slot: 'sample', format: getSampleSatate },
      { label: '采样编号', prop: 'sampleNum' },
      { label: '采样状态', prop: 'sampleState', format: getSampleSatate },
      {
        label: '标况/工况',
        prop: ['sampleStandardVolume', 'sampleVolume'],
        format: getVolumVal
      }
    ],
    [
      { label: '门状态', prop: 'doorState', format: getDoorState },
      { label: '载体状态', prop: 'vehicleState', format: getVehicleState },
      { label: '流量', prop: 'sampleFlow', unit: 'L/min' },
      { label: '倒计时', prop: 'sampleCountDown', format: v => (v ? throughTime(v) : v) }
    ]
  ],
  [
    [
      { label: 'WI-FI状态', prop: 'wifiState', format: getWifiState },
      { label: '设备电量', prop: 'batteryCapacity', unit: '%' }
    ]
  ]
];

export const pageTopGroupClassNames = ['group1', 'group2', 'group3'];
export const colors = ['rgb(157, 102, 241)', 'rgb(13, 204, 238)', 'rgb(23, 151, 255)'];
export const serieStyles = [
  {
    areaStyle: {
      color: graColor('rgba(157, 102, 241, 1)', 'rgba(157, 102, 241, 0.12)')
    }
  },
  {
    areaStyle: {
      color: graColor('rgba(13, 204, 238, 1)', 'rgba(13, 204, 238, 0.12)')
    }
  },
  {
    areaStyle: {
      color: graColor('rgba(23, 151, 255, 1)', 'rgba(23, 151, 255, 0.12)')
    }
  }
];

export const chartConfigs = [
  {
    title: '标况采样体积',
    unit: 'L',
    data: []
  },
  {
    title: '工况采样体积',
    unit: 'L',
    data: []
  },
  {
    title: '流量',
    unit: 'L/min',
    data: []
  },
  {
    title: '温度',
    unit: '℃',
    data: []
  },
  {
    title: '湿度',
    unit: '%RH',
    data: []
  },
  {
    title: '气压',
    unit: 'kpa',
    data: []
  }
];
